export default __webpack_public_path__ + "static/media/section1-img3.c4287b41.png";